import React from 'react';

export const handleChangeDate = (e: any, callback: Function, day: number) => {
  if (e.target.value.length >= 2 || e.target.value == 'e') {
    if (
      e.target.value <= day &&
      e.target.value !== '00' &&
      e.target.value != '000'
    ) {
      console.log('hello', e.target.value.slice(0, 1));
      e.target.parentNode.nextSibling.firstElementChild.focus();
    }

    e.target.value = e.target.value.slice(0, 2);
  }
  callback(e);
};

export const handleChangeMonth = (
  e: any,
  callback: Function,
  month: number,
) => {
  if (e.target.value) {
    if (e.target.value.length >= 2 || e.target.value == 'e') {
      if (
        e.target.value <= month &&
        e.target.value !== '00' &&
        e.target.value != '000'
      ) {
        e.target.parentNode.nextSibling.firstElementChild.focus();
      }
    }
    e.target.value = e.target.value.slice(0, 2);
  }
  callback(e);
};

export const validateDOBPayload = ( payload:any, day: number, month: number, currentYear: number) => {
  if (payload?.DateOfBirthDay != undefined &&
    (parseInt(payload?.DateOfBirthDay) > day ||
      parseInt(payload?.DateOfBirthDay) <= 0)
  ) {
   return true;
  }
  if (payload?.DateOfBirthMonth != undefined &&
    (parseInt(payload?.DateOfBirthMonth) > month ||
      parseInt(payload?.DateOfBirthMonth) <= 0)
  ) {
    return true;
  }
  if (payload?.DateOfBirthYear != undefined &&
    (payload?.DateOfBirthYear.length < 4 ||
      parseInt(payload?.DateOfBirthYear) <= 0 ||
      parseInt(payload?.DateOfBirthYear) < 1900 ||
      parseInt(payload?.DateOfBirthYear) > currentYear
    )
  ) {
    return true;
  }
};